module.exports = __webpack_public_path__ + "static/media/ervin.0962831c.jpg";